import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import styled from 'styled-components';
import { font, color } from '@design/templateFns';

interface LinkProps extends NextLinkProps {
  children?: any;
  dataTestId?: string;
}

const StyledLink = styled.a`
  ${font('subhead-xs')};
  color: ${color('gray4')};
  text-decoration: underline;
  text-underline-offset: 4px;

  a:visited {
    color: initial;
  }
`;

const Link = (props: LinkProps) => {
  //weird unicorn outlier case
  if (`${props.href}`.startsWith('/#')) {
    return (
      <StyledLink href={'#'} data-testid={props.dataTestId}>
        {props.children}
      </StyledLink>
    );
  }

  // on page anchors
  if (`${props.href}`.startsWith('#')) {
    return (
      <StyledLink href={`${props.href}`} data-testid={props.dataTestId}>
        {props.children}
      </StyledLink>
    );
  }

  // off-site links. (we don't use relative links)
  if (!`${props.href}`.startsWith('/')) {
    return (
      <StyledLink target="_blank" href={`${props.href}`} data-testid={props.dataTestId}>
        {props.children}
      </StyledLink>
    );
  }

  // explicit hardloads
  if (`${props.href}`.indexOf('hl=1') !== -1) {
    return (
      <StyledLink href={`${props.href}`} data-testid={props.dataTestId}>
        {props.children}
      </StyledLink>
    );
  }

  // normal on-site links, using next routing
  return <NextLink {...props} legacyBehavior />;
};

export default Link;
